import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

const ClassesMultiSelect = props => {
    const { classes, selectedClassIds, onChange, width = 200} = props;

    return (
        <Select
            aria-label="classes"
            mode="multiple"
            allowClear={true}
            placeholder="Select classes"
            value={selectedClassIds}
            onChange={onChange}
            style={{width: width}}
        >
            {classes.map((item) => (
                <Option key={item.classId} value={item.classId}>
                    {item.className}
                </Option>
            ))}
        </Select>
    )
}

export default ClassesMultiSelect;